import React, { useEffect, useState } from "react";
import Image from "next/image";
import Link from "next/link";
import styles from "./ImageBanner.module.css";

interface ImageBannerProps {
  data: any;
}

const ImageBanner: React.FC<ImageBannerProps> = ({ data }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Set initial value
    handleResize();

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const imageSrc = isMobile ? data?.mobile_img.url : data?.desktop_img.url;
  const imageAlt = isMobile
    ? data?.mobile_img.alternativeText
    : data?.desktop_img.alternativeText || "Banner Image";

  const ImageComponent = (
    <div className={`${styles.imageBanner}`}>
      <Image
        src={imageSrc}
        alt={imageAlt}
        width={1920}
        height={1080}
        style={{
          width: "100%",
          height: "auto",
          objectFit: "contain",
          maxHeight: "none",
          // aspectRatio: "16/9",
        }}
        priority
        fetchPriority="high"
        unoptimized={false}
      />
    </div>
  );

  // If URL is provided, wrap in Link component
  if (data?.url) {
    return (
      <Link
        href={data?.url}
        className={styles.bannerLink}
        target="_blank"
        rel="noopener noreferrer"
      >
        {ImageComponent}
      </Link>
    );
  }

  // Otherwise return as static image
  return ImageComponent;
};

export default ImageBanner;
